export const RESOURCE_SECTIONS = {
  'digital-products': {
    label: 'Digital Products',
    eyebrow: 'ORIGENNE\u2122 \u00b7 Digital Products',
    title: 'The library.',
    accent: 'Delivered instantly.',
    intro: 'eBooks, workbooks, templates, guides, and toolkits for founders building with intention. Free and paid resources, delivered directly from my Founder HQ.',
    metaDescription: 'eBooks, workbooks, templates, guides, and toolkits from Toia Wallace, delivered instantly from ORIGENNE\u2122, her personal Founder HQ.',
  },
  'business-templates': {
    label: 'Business Templates',
    eyebrow: 'ORIGENNE\u2122 \u00b7 Business Templates',
    title: 'Business',
    accent: 'Templates.',
    intro: 'Founder-tested operating documents, decks, and frameworks.',
    metaDescription: 'Founder-tested operating documents, decks, and frameworks from Toia Wallace.',
  },
  'ai-resources': {
    label: 'AI Resources',
    eyebrow: 'ORIGENNE\u2122 \u00b7 AI Resources',
    title: 'AI',
    accent: 'Resources.',
    intro: 'Guides on deploying AI inside a founder-led company.',
    metaDescription: 'Guides from Toia Wallace on deploying AI inside a founder-led company.',
  },
  'founder-insights': {
    label: 'Founder Insights',
    eyebrow: 'ORIGENNE\u2122 \u00b7 Founder Insights',
    title: 'Founder',
    accent: 'Insights.',
    intro: 'Essays and dispatches from the desk of Toia Wallace.',
    metaDescription: 'Essays and dispatches from the desk of Toia Wallace.',
  },
  journal: { label: 'The Journal' },
};

export const resourceHref = (item, section) => {
  const sec = section && item.sections?.includes(section) ? section : item.sections?.[0] || 'digital-products';
  if (item.content_type === 'article' && sec === 'journal') return `/journal/${item.slug}`;
  return `/resources/${sec}/${item.slug}`;
};

export const formatMonthYear = (iso) =>
  iso ? new Date(`${iso}T12:00:00Z`).toLocaleDateString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' }) : '';
